<template>
  <!-- Page Content -->
  <div
    class="whole-page-long"
    :style="{
      backgroundImage: 'url(' + backgroundImg + ')',
      overflow: 'auto',
      height: '100%',
    }"
  >
    <div class="navbar-div">
      <NavbarComponent
        :colorTheme="colorTheme"
        :user="user"
        analysis="PROFILE"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>

    <div class="row f-row justify-content-center h-100">
      <div class="col col-12 f-row">
        <div class="h-100 d-flex flex-column">
          <!-- First row: controls -->
          <div class="row f-row mt-4">
            <div class="col col-1"></div>
            <div class="col col-1">
              <div class="circle-profile-div circle-profile-small">
                {{ user.first_name.substring(0, 1)
                }}{{ user.last_name.substring(0, 1) }}
              </div>
            </div>
            <div class="col col-10">PROFILE INFORMATION</div>
          </div>
          <!-- Second row: buttons -->
          <div
            class="col col-lg-12 text-center progress-div"
            v-if="showLoading"
          >
            <QSLoading
              :isLoading="showLoadingSpot"
              :size="40"
              :colorTheme="colorTheme"
            />
          </div>
          <div class="row f-row mt-3 scrl80 justify-content-center" v-else>
            <!--                        <div class="col col-1"></div>-->
            <!--                        <div class="col col-1">-->
            <!--                            <div class="circle-profile-div">-->
            <!--                                {{ user.first_name.substring(0,1) }}{{ user.last_name.substring(0,1) }}-->
            <!--                            </div>-->
            <!--                        </div>-->
            <div class="col col-5" style="padding-right: 5px;">
              <table class="table table-borderless table-profile-user">
                <tbody>
                  <tr>
                    <th scope="row" style="width:240px">First name:</th>
                    <td>{{ user.first_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Last name:</th>
                    <td>{{ user.last_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Username:</th>
                    <td>{{ user.username }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">
                      <i class="fa fa-envelope"></i>
                    </th>
                    <td>{{ user.email }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Phone:</th>
                    <td>{{ user.phone }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Country:</th>
                    <td v-if="user.Country != null">
                      {{ country[user.Country - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">City:</th>
                    <td>{{ user.city }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Address:</th>
                    <td>{{ user.address }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col col-5" style="padding-left: 5px;">
              <table class="table table-profile-user">
                <tbody>
                  <tr>
                    <th scope="row" style="width:240px">Company:</th>
                    <td>{{ user.company }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Role:</th>
                    <td v-if="user.role != null && user.role !== 0">
                      {{ roles[user.role - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Web page:</th>
                    <td>{{ user.web_page }}</td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Sector:</th>
                    <td v-if="user.sector != null && user.sector !== 0">
                      {{ sector[user.sector - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Sales:</th>
                    <td v-if="user.Ventas != null && user.Ventas !== 0">
                      {{ ventas[user.Ventas - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">
                      Foreign Currency Exposure:
                    </th>
                    <td
                      v-if="
                        user.foreign_currency_exposure != null &&
                          user.foreign_currency_exposure !== 0
                      "
                    >
                      {{ listForeign[user.foreign_currency_exposure - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr v-if="validateForeign">
                    <th scope="row" style="width:240px">
                      Type Foreign Currency Exposure:
                    </th>
                    <td
                      v-if="
                        user.type_foreign_currency_exposure != null &&
                          user.type_foreign_currency_exposure !== 0
                      "
                    >
                      {{
                        typeForeign[user.type_foreign_currency_exposure - 1]
                          .name
                      }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr>
                    <th scope="row" style="width:240px">Commodity exposure:</th>
                    <td
                      v-if="
                        user.commodity_exposure != null &&
                          user.commodity_exposure !== 0
                      "
                    >
                      {{ listCommodity[user.commodity_exposure - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                  <tr v-if="validateCommodity">
                    <th scope="row" style="width:240px">
                      Type Commodity Exposure:
                    </th>
                    <td
                      v-if="
                        user.type_commodity_exposure != null &&
                          user.type_commodity_exposure !== 0
                      "
                    >
                      {{ typeCommodity[user.type_commodity_exposure - 1].name }}
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col col-10 text-center align-content-center">
              <router-link :to="{ name: 'edituser' }" class="nav-link">
                <button class="btn btn-sm btn-markets" style="width: 100px;">
                  EDIT
                </button>
              </router-link>
            </div>
          </div>
          <!-- Conditional: edit -->
          <div
            class="row text-center"
            style="vertical-align: middle!important;padding: 1px 0 1px 0"
            v-if="user.last_name === ''"
          >
            <transition name="fadeAppDes">
              <div class="col col-12 home-new-user row-bckgrnd h-100">
                Please click EDIT to enter your Name.
              </div>
            </transition>
          </div>
          <!-- Conditional: company + portfolio -->
          <div
            class="row text-center"
            style="vertical-align: middle!important;padding: 1px 0 1px 0"
            v-else-if="companyLen === 0"
          >
            <transition name="fadeAppDes">
              <div class="col col-12 home-new-user row-bckgrnd h-100">
                Please click here to go to
                <router-link
                  :to="{ name: 'overview' }"
                  class="text-info text-title text-link"
                  style="padding-right: 0"
                >
                  <span class="text-info text-title text-link">Overview</span>
                </router-link>
                or
                <router-link
                  :to="{ name: 'data' }"
                  class="text-info text-title text-link"
                  style="padding-right: 0"
                >
                  <span class="text-info text-title text-link">Data Model</span>
                </router-link>
                to create Your Company and Portfolios
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <!--    <MainMenuComponent />-->
  </div>
</template>

<script>
// import MainMenuComponent from "../components/home/MainMenuComponent"
// import { getProfileCatalogs } from "@/_core/data/api_calls/catalogs/getProfileCatalogs";
import { apiService } from "@/_services";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { colorThemeChange, colorThemeVuex } from "@/_core/_helpers/_helpers";
import NavbarComponent from "../components/Navbar.vue";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "profile",
  components: {
    NavbarComponent,
    QSLoading,
  },
  data() {
    return {
      backgroundImg: require("@/assets/images/PTTSymmetryOscura02.jpg"),
      colorTheme: true, // true = dark, else light
      companies: [],
      companyLen: 1,
      country: [{ id: 1, name: "Colombia" }],
      currencies: [],
      currencySpecs: [],
      currentCompany: [],
      exposure: 0,
      form: {
        username: "",
        first_name: "",
        last_name: "",
        email: "",
      },
      hedgePercentage: 0,
      hedges: 0,
      listForeign: [
        { id: 1, name: "Yes" },
        { id: 2, name: "No" },
      ],
      listCommodity: [
        { id: 1, name: "Yes" },
        { id: 2, name: "No" },
      ],
      overview_preferences: {},
      planningChartData: null,
      portfolios: [],
      required: 0,
      roles: [
        { id: 1, name: "Board Member" },
        { id: 2, name: "CEO" },
        { id: 3, name: "CFO" },
        { id: 4, name: "Treasurer" },
        { id: 5, name: "Purchasing Manager" },
        { id: 6, name: "Sales Manager" },
        { id: 7, name: "Analyst" },
      ],
      root: document.documentElement,
      sector: [{ id: 1, name: "Accountants" }],
      selectedCompany: 0,
      selectedCurrency: 0,
      selectedPortfolios: 0,
      showLoading: false,
      spot: null,
      spotData: null,
      strategy: 0,
      tableData: [],
      typeCommodity: [
        { id: 1, name: "Producer" },
        { id: 2, name: "Consumer" },
        { id: 3, name: "Both" },
      ],
      typeForeign: [
        { id: 1, name: "Exporter" },
        { id: 2, name: "Importer" },
        { id: 3, name: "Both" },
      ],
      validateCommodity: false,
      validateForeign: false,
      ventas: [{ id: 1, name: "$0-$1M" }],
      user: {
        first_name: "N",
        last_name: "C",
        username: "__",
        email: "__",
        phone: "__",
        Country: 1,
        city: "__",
        address: "__",
        company: "__",
        role: 1,
        web_page: "__",
        sector: 1,
        Ventas: 1,
        foreign_currency_exposure: 1,
        type_foreign_currency_exposure: 1,
        commodity_exposure: 1,
        type_commodity_exposure: 1,
        habeas_data: true,
        pk_idusers: 2,
      },
    };
  },
  created() {
    this.overview_preferences = this.$store.state.user_preferences.all.items.overview_choices;
    try {
      this.colorTheme = this.overview_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        this.backgroundImg = require("@/assets/images/PTTSymmetryClara01.jpg");
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    this.showLoading = true;
    this.getTerms();
    try {
      this.user = this.$store.state.user.all.items;
      if (this.user.foreign_currency_exposure === 1) {
        this.validateForeign = true;
      }
      if (this.user.commodity_exposure === 1) {
        this.validateCommodity = true;
      }
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
    } catch (error) {
      console.log(`Error currencies ${error}`);
    }
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.log(`Error countries ${error}`);
    }

    document.title = "Profile | Quanspire";
  },
  watch: {
    companies() {
      this.companyLen = this.companies.length;
    },
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      if (this.colorTheme) {
        this.backgroundImg = require("@/assets/images/PTTSymmetryOscura02.jpg");
        this.logo_white = require("@/assets/images/QuanspireLogoWhite.svg");
        this.logo = require("@/assets/images/QuanspireLogoWhite.svg");
      } else if (!this.colorTheme) {
        this.backgroundImg = require("@/assets/images/PTTSymmetryClara01.jpg");
        this.logo_white = require("@/assets/images/QuanspireLogoBlack.svg");
        this.logo = require("@/assets/images/QuanspireLogoBlack.svg");
      }
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    getTerms: function() {
      let params = {
        method: "GET",
        endpoint: "catalogs_profile",
        query_params: {
          format: "json",
        },
      };
      apiService.getAll(params).then((data) => {
        console.log(data);
        if (data != null) {
          this.roles = Object.values(
            data[0]["RoleEditProfile"].RoleEditProfile,
          );
          this.sector = Object.values(
            data[0]["SectorEditProfile"].SectorEditProfile,
          );
          this.ventas = Object.values(
            data[0]["SalesEditProfile"].SalesEditProfile,
          );
          this.country = Object.values(
            data[0]["CountryEditProfile"].CountryEditProfile,
          );
          this.listCommodity = Object.values(
            data[0]["SelectEditProfile"].SelectEditProfile,
          );
          this.listForeign = Object.values(
            data[0]["SelectEditProfile"].SelectEditProfile,
          );
          this.typeCommodity = Object.values(
            data[0]["TypeCommodityEditProfile"].TypeCommodityEditProfile,
          );
          this.showLoading = false;
        }
      });
    },
  },
};
</script>
